module.exports = __webpack_public_path__ + "img/collect-icon.69615c0.png";